import React, { FC, ReactElement, useRef, useState } from "react";

import { Button } from "./button";

interface SkipCodeProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement<any>;
  translations: {
    codeBlockSkipped: string;
    skipCodeBlock: string;
  };
}
const SkipCode: FC<SkipCodeProps> = ({ children, translations }) => {
  const targetRef = useRef<HTMLParagraphElement>(null);
  const [hideTarget, setHideTarget] = useState(true);
  const [hideTargetText, setHideTargetText] = useState(true);
  const t = translations;
  const handleSkip = () => {
    if (targetRef.current) {
      setHideTarget(false);
      setHideTargetText(false);
      setTimeout(() => {
        if (targetRef.current) targetRef?.current?.focus();
      }, 150);
      setTimeout(() => {
        setHideTargetText(true);
      }, 5000);
    }
  };

  return (
    <>
      <Button
        className="absolute left-4 top-4 z-[1000] -translate-y-full bg-black opacity-0 transition-transform focus:translate-y-0 focus:opacity-100 reduce-motion:transition-none"
        onClick={handleSkip}
        variant="small"
      >
        {t.skipCodeBlock}
      </Button>
      {children}
      <p
        className="visually-hidden"
        hidden={hideTarget}
        onBlur={() => setHideTarget(true)}
        ref={targetRef}
        /* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex */
        tabIndex={0}
      >
        {!hideTargetText && t.codeBlockSkipped}
      </p>
    </>
  );
};
export default SkipCode;
